export default IconChristmasBall => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-christmas-ball" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 13m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" />
  <path d="M11 5l1 -2l1 2" />
  <path d="M4.512 10.161c2.496 -1.105 4.992 -.825 7.488 .839c2.627 1.752 5.255 1.97 7.882 .653" />
  <path d="M4.315 15.252c2.561 -1.21 5.123 -.96 7.685 .748c2.293 1.528 4.585 1.889 6.878 1.081" />
</svg>`;